var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: "display: flex;width: 780px;" }, [
    _c(
      "div",
      { staticClass: "form-column" },
      [
        _c("el-form", { staticClass: "result-form" }, [
          _c("table", { attrs: { cellpadding: "0", cellspacing: "0" } }, [
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("FileHistory.fileName")))
              ]),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.details.fileName))
                ])
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.SerialNo")))
              ]),
              _c("td", [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.details.fileNo))
                ])
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.BusinessNumber")))
              ]),
              _c("td", [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.details.jobNo))
                ])
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Hbl2")))
              ]),
              _c("td", [
                _c("span", { staticStyle: { "margin-left": "10px" } })
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Mbl2")))
              ]),
              _c("td", [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.resultJson.billNo))
                ])
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.SoNo")))
              ]),
              _c("td", [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.resultJson.soNo))
                ])
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.WarehouseNo")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "1" },
                    model: {
                      value: _vm.resultJson.warehouseReceiptNo,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "warehouseReceiptNo", $$v)
                      },
                      expression: "resultJson.warehouseReceiptNo"
                    }
                  })
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                _vm._v(_vm._s(_vm.$t("Message.Shipper")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "2" },
                        model: {
                          value: _vm.job.shipperLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "shipperLine1", $$v)
                          },
                          expression: "job.shipperLine1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "3" },
                          on: { change: _vm.mapperBlType },
                          model: {
                            value: _vm.resultJson.blType,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "blType", $$v)
                            },
                            expression: "resultJson.blType"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        attrs: { no: "4" },
                        model: {
                          value: _vm.job.orderType,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "orderType", $$v)
                          },
                          expression: "job.orderType"
                        }
                      },
                      _vm._l(_vm.blModeList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.name, value: item.serialNumber }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "5" },
                        model: {
                          value: _vm.job.shipperLine2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "shipperLine2", $$v)
                          },
                          expression: "job.shipperLine2"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.LCL")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "6" },
                          on: { change: _vm.mapperLoadType },
                          model: {
                            value: _vm.resultJson.fclOrLcl,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "fclOrLcl", $$v)
                            },
                            expression: "resultJson.fclOrLcl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        attrs: { no: "7" },
                        model: {
                          value: _vm.job.containerLoadType,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "containerLoadType", $$v)
                          },
                          expression: "job.containerLoadType"
                        }
                      },
                      _vm._l(_vm.containerLoadTypes, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "8" },
                        model: {
                          value: _vm.job.shipperLine3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "shipperLine3", $$v)
                          },
                          expression: "job.shipperLine3"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ShippingCompany")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "9" },
                          on: { change: _vm.mapperShipName },
                          model: {
                            value: _vm.resultJson.carrier,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "carrier", $$v)
                            },
                            expression: "resultJson.carrier"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-company-select", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        no: "10",
                        "method-params": {
                          companyLob: "seaExport",
                          seaCmp: true,
                          active: true
                        },
                        "default-value": _vm.job.carrierId || ""
                      },
                      on: {
                        change: function(p) {
                          _vm.job.carrierId = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "11" },
                        model: {
                          value: _vm.job.shipperLine4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "shipperLine4", $$v)
                          },
                          expression: "job.shipperLine4"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.vessel")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "12" },
                        model: {
                          value: _vm.resultJson.vessel,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "vessel", $$v)
                          },
                          expression: "resultJson.vessel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "13" },
                        model: {
                          value: _vm.job.shipperLine5,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "shipperLine5", $$v)
                          },
                          expression: "job.shipperLine5"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.voyage")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "14" },
                        model: {
                          value: _vm.resultJson.voyage,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "voyage", $$v)
                          },
                          expression: "resultJson.voyage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "15" },
                        model: {
                          value: _vm.job.shipperLine6,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "shipperLine6", $$v)
                          },
                          expression: "job.shipperLine6"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("queryJob.dateOfDeparture")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "16" },
                          on: { change: _vm.mapperEtd },
                          model: {
                            value: _vm.resultJson.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "etd", $$v)
                            },
                            expression: "resultJson.etd"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-date-picker", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        no: "17",
                        value: _vm.job.etd,
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      on: { input: _vm.etdChange }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "18" },
                        model: {
                          value: _vm.job.shipperLine7,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "shipperLine7", $$v)
                          },
                          expression: "job.shipperLine7"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.contactPerson")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "19" },
                        model: {
                          value: _vm.resultJson.email,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "email", $$v)
                          },
                          expression: "resultJson.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                _vm._v(_vm._s(_vm.$t("Message.Consignee")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "20" },
                        model: {
                          value: _vm.job.consigneeLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "consigneeLine1", $$v)
                          },
                          expression: "job.consigneeLine1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.TransportationClause")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "21" },
                          on: { change: _vm.mapperFreightTerm },
                          model: {
                            value: _vm.resultJson.serviceTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "serviceTerm", $$v)
                            },
                            expression: "resultJson.serviceTerm"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        no: "22",
                        "select-type":
                          _vm.selectTypeNames.basic_data_ShippingTerm,
                        filterable: "",
                        clearable: false,
                        "default-value": _vm.job.freightTerm
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.freightTerm = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "23" },
                        model: {
                          value: _vm.job.consigneeLine2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "consigneeLine2", $$v)
                          },
                          expression: "job.consigneeLine2"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.FreightTerm")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "24" },
                          on: { change: _vm.mapperPaymentTerm },
                          model: {
                            value: _vm.resultJson.freightClauseName,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "freightClauseName", $$v)
                            },
                            expression: "resultJson.freightClauseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        no: "25",
                        "select-type":
                          _vm.selectTypeNames.basic_data_PaymentTerm,
                        filterable: "",
                        clearable: false,
                        "default-value": _vm.job.paymentTermMBL
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.paymentTermMBL = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "27" },
                        model: {
                          value: _vm.job.consigneeLine3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "consigneeLine3", $$v)
                          },
                          expression: "job.consigneeLine3"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header", attrs: { rowspan: "2" } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ContainerSize")))
              ]),
              _c(
                "td",
                { attrs: { rowspan: "2" } },
                _vm._l(_vm.job.seaEQ, function(item, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "49%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "40px" },
                            attrs: {
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_ContainerAmount"
                              ),
                              no: "eqQuantity"
                            },
                            model: {
                              value: item.eqQuantity,
                              callback: function($$v) {
                                _vm.$set(item, "eqQuantity", $$v)
                              },
                              expression: "item.eqQuantity"
                            }
                          }),
                          _vm._v(" " + _vm._s(item.showEQ) + " ")
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "75px" },
                            attrs: {
                              no: "eqSize",
                              "select-type":
                                _vm.selectTypeNames.local_cache_EQSize,
                              fields: ["code"],
                              filterable: "",
                              placeholder: " ",
                              "show-copy": false,
                              "default-value": item.eqSize,
                              "tag-name": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.changeSizeCallBack(item, p)
                              }
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "75px" },
                            attrs: {
                              no: "eqType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_EQType,
                              fields: ["code"],
                              filterable: "",
                              placeholder: " ",
                              "show-copy": false,
                              "default-value": item.eqType,
                              "tag-name": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.changeTypeCallBack(item, p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                }),
                0
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "29" },
                        model: {
                          value: _vm.job.consigneeLine4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "consigneeLine4", $$v)
                          },
                          expression: "job.consigneeLine4"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "31" },
                        model: {
                          value: _vm.job.consigneeLine5,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "consigneeLine5", $$v)
                          },
                          expression: "job.consigneeLine5"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "34" },
                        model: {
                          value: _vm.job.consigneeLine6,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "consigneeLine6", $$v)
                          },
                          expression: "job.consigneeLine6"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "36" },
                        model: {
                          value: _vm.job.consigneeLine7,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "consigneeLine7", $$v)
                          },
                          expression: "job.consigneeLine7"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                _vm._v(_vm._s(_vm.$t("Message.Notify")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "37" },
                        model: {
                          value: _vm.job.notifyLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "notifyLine1", $$v)
                          },
                          expression: "job.notifyLine1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "38" },
                        model: {
                          value: _vm.resultJson.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "quantity", $$v)
                          },
                          expression: "resultJson.quantity"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "39" },
                        model: {
                          value: _vm.job.notifyLine2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "notifyLine2", $$v)
                          },
                          expression: "job.notifyLine2"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Package")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "40" },
                          on: { change: _vm.mapperPacking },
                          model: {
                            value: _vm.resultJson.packageType,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "packageType", $$v)
                            },
                            expression: "resultJson.packageType"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-packing-select", {
                      staticStyle: { width: "180px" },
                      attrs: { "default-value": _vm.job.packing, no: "41" },
                      on: {
                        change: function(p) {
                          _vm.job.packing = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "42" },
                        model: {
                          value: _vm.job.notifyLine3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "notifyLine3", $$v)
                          },
                          expression: "job.notifyLine3"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "43" },
                        model: {
                          value: _vm.resultJson.grossWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "grossWeight", $$v)
                          },
                          expression: "resultJson.grossWeight"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "44" },
                        model: {
                          value: _vm.job.notifyLine4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "notifyLine4", $$v)
                          },
                          expression: "job.notifyLine4"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "45" },
                        model: {
                          value: _vm.resultJson.measurement,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "measurement", $$v)
                          },
                          expression: "resultJson.measurement"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "46" },
                        model: {
                          value: _vm.job.notifyLine5,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "notifyLine5", $$v)
                          },
                          expression: "job.notifyLine5"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "47" },
                        model: {
                          value: _vm.job.notifyLine6,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "notifyLine6", $$v)
                          },
                          expression: "job.notifyLine6"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "48" },
                        model: {
                          value: _vm.job.notifyLine7,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "notifyLine7", $$v)
                          },
                          expression: "job.notifyLine7"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PlaceOfReceipt")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "49" },
                          on: {
                            change: function($event) {
                              return _vm.mapperSeaPort(
                                "destinationPortCode",
                                "portOfReceipt"
                              )
                            }
                          },
                          model: {
                            value: _vm.resultJson.portOfReceipt,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "portOfReceipt", $$v)
                            },
                            expression: "resultJson.portOfReceipt"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        no: "50",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.job.destinationPortCode,
                        "tag-name": "englishName"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.destinationPortCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.portOfLoading")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "51" },
                          on: {
                            change: function($event) {
                              return _vm.mapperSeaPort(
                                "loadingPortCode",
                                "portOfLoading"
                              )
                            }
                          },
                          model: {
                            value: _vm.resultJson.portOfLoading,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "portOfLoading", $$v)
                            },
                            expression: "resultJson.portOfLoading"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        no: "52",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.job.loadingPortCode,
                        "tag-name": "englishName"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.loadingPortCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("queryJob.dischargingPortCode")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "53" },
                          on: {
                            change: function($event) {
                              return _vm.mapperSeaPort(
                                "dischargingPortCode",
                                "portOfDischarge"
                              )
                            }
                          },
                          model: {
                            value: _vm.resultJson.portOfDischarge,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "portOfDischarge", $$v)
                            },
                            expression: "resultJson.portOfDischarge"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        no: "54",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.job.dischargingPortCode
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.dischargingPortCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("queryJob.placeOfDelivery")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "55" },
                          on: {
                            change: function($event) {
                              return _vm.mapperSeaPort(
                                "destinationPortCode",
                                "placeOfDelivery"
                              )
                            }
                          },
                          model: {
                            value: _vm.resultJson.placeOfDelivery,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "placeOfDelivery", $$v)
                            },
                            expression: "resultJson.placeOfDelivery"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        no: "56",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.job.destinationPortCode
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.destinationPortCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Marks")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          resize: "none",
                          rows: 10,
                          no: "57"
                        },
                        model: {
                          value: _vm.resultJson.marks,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "marks", $$v)
                          },
                          expression: "resultJson.marks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Pricing.Goods")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          resize: "none",
                          rows: 10,
                          no: "58"
                        },
                        model: {
                          value: _vm.resultJson.goodsDescription,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "goodsDescription", $$v)
                          },
                          expression: "resultJson.goodsDescription"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                { attrs: { colspan: "4" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "800px", height: "200px" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.goods.gridOptions,
                      "column-defs": _vm.goodsColumnDefs,
                      "row-data": _vm.goods.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.goods.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.remarks")))
              ]),
              _c(
                "td",
                { attrs: { colspan: "3" } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          resize: "none",
                          rows: 5,
                          no: "59"
                        },
                        model: {
                          value: _vm.resultJson.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "remark", $$v)
                          },
                          expression: "resultJson.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }